/** المرحلة 8 (المالية والتحليلات) — رسائل الأخطاء وأسماء الصلاحيات بالعربية (ADR-801). */
export const faz8ErrorsAr = {
  shipment_cost_exists: 'تكلفة الشحن مسجّلة لهذه الشحنة بالفعل؛ عدّل السجل الموجود.',
  vat_exceeds_amount: 'لا يمكن أن تتجاوز ضريبة القيمة المضافة المبلغ الإجمالي.',
  tracking_not_found: 'لا توجد شحنة برقم التتبع هذا.',
  tracking_ambiguous: 'رقم التتبع هذا يخص عدة شحنات؛ أدخل التكلفة من صفحة الشحنة.',
  duplicate_in_file: 'رقم التتبع هذا مكرّر في الملف.',
  amount_required: 'المبلغ فارغ أو غير مقروء.',
  date_unreadable: 'تاريخ غير مقروء (DD.MM.YYYY أو YYYY-MM-DD).',
  cost_file_columns_missing: 'لا يحتوي الملف على عمودي «Takip no» (رقم التتبع) و«Tutar» (المبلغ).',
  supplier_code_exists: 'يوجد مورّد بهذا الرمز بالفعل.',
  supplier_inactive: 'المورّد غير نشط؛ فعّله أولًا.',
  purchase_order_not_editable:
    'بعد إرسال الطلب إلى المورّد لا يمكن تغيير البنود والمستودع والعملة؛ يمكن تعديل التاريخ المتوقع والملاحظة فقط.',
  purchase_order_status: 'لا يمكن تنفيذ هذا الإجراء في الحالة الحالية لأمر الشراء.',
  purchase_order_not_receivable:
    'لا يمكن استلام البضائع إلا للأوامر المرسلة إلى المورّد وغير المستلمة بالكامل.',
  warehouse_inactive: 'المستودع غير نشط؛ فعّله لاستلام البضائع.',
  duplicate_variant: 'لا يمكن أن يظهر المنتج نفسه في أكثر من بند؛ أدخل الكمية في بند واحد.',
  over_receipt: 'الكمية المستلمة تتجاوز الكمية المتبقية؛ فعّل الخيار لقبول التسليم الزائد.',
  duplicate_line: 'لا يمكن أن يتكرر بند الطلب نفسه مرتين في استلام واحد.',
  lot_expiry_mismatch: 'رقم الدفعة هذا مسجّل بتاريخ انتهاء صلاحية مختلف.',
  supplier_entry_not_reversible:
    'لا يمكن عكس فاتورة استلام البضائع؛ صحّح الفرق بقيد تسوية. ولا يمكن عكس قيد عكسي.',
  report_metric_invalid: 'هذا المؤشر غير متاح في مجموعة البيانات المختارة.',
  report_dimension_invalid: 'هذا البُعد غير متاح في مجموعة البيانات المختارة.',
  report_duplicate: 'لا يمكن اختيار المؤشر أو البُعد نفسه مرتين.',
  report_pivot_one_metric: 'عند اختيار بُعد للأعمدة (جدول محوري) اختر مؤشرًا واحدًا.',
  report_filter_invalid: 'لا يمكن استخدام هذا المرشّح مع مجموعة البيانات المختارة.',
  report_definition_invalid: 'تعذّرت قراءة تعريف التقرير.',
  dashboard_widget_limit: 'يمكنك إضافة {{max}} عنصرًا كحد أقصى إلى لوحة المعلومات.',
  dashboard_widget_exists: 'هذا التقرير موجود بالفعل في لوحة معلوماتك.',
  widget_order_mismatch: 'يجب أن يتضمن الترتيب كل عنصر مرة واحدة بالضبط.',
  report_export_not_ready: 'الملف غير جاهز بعد أو تعذّر إنشاؤه.',
  report_export_too_large: 'يتجاوز الملف حد 20 ميغابايت؛ أضف مرشّحًا أو قلّل أبعاد الصفوف.',
  report_member_inactive: 'عضوية المستخدم غير نشطة؛ لم يُنشأ أي ملف.',
  no_eligible_recipient: 'لا يملك أي مستلم صلاحية رؤية هذا التقرير؛ لم يُرسل أي بريد.',
  payment_not_disputable:
    'لا يمكن تسجيل اعتراض إلا على دفعة محصّلة بالبطاقة (iyzico أو PayTR) أو عبر جهاز نقاط بيع فعلي.',
  dispute_exceeds_payment: 'مبلغ الاعتراض يتجاوز الجزء غير المعترض عليه من الدفعة.',
  dispute_fee_too_large: 'لا يمكن أن تتجاوز رسوم الاعتراض مبلغ الدفعة.',
  dispute_case_exists: 'يوجد بالفعل اعتراض بهذا الرقم المرجعي لهذه الدفعة.',
  dispute_status_transition: 'لا يمكن نقل الاعتراض من حالته الحالية إلى هذه الحالة.',
  date_before_opened: 'لا يمكن أن يسبق هذا التاريخ تاريخ فتح الاعتراض.',
  date_after_closed: 'لا يمكن أن يأتي تاريخ الفتح بعد تاريخ الإغلاق.',
  simulation_currency_unsupported: 'محاكاة الأسعار تدعم حاليًا قوائم الأسعار بالليرة التركية (TRY) فقط.',
  workflow_field_invalid: 'هذا الحقل غير موجود في المشغّل المختار.',
  workflow_operator_invalid: 'لا يمكن استخدام هذه المقارنة مع هذا الحقل.',
  workflow_value_invalid: 'القيمة لا تناسب هذا الحقل (يُتوقع رقم أو خيار أو نص).',
  workflow_actions_required: 'أضف إجراءً واحدًا على الأقل.',
  workflow_action_incompatible: 'لا يمكن استخدام هذا الإجراء مع المشغّل المختار.',
  workflow_recipient_invalid: 'أحد المستلمين ليس عضوًا نشطًا في المنشأة.',
  saved_report_not_found: 'لم يُعثر على التقرير المحفوظ أو لا تملك صلاحية رؤيته.',
  workflow_template_linked:
    'هذا المثال يرسل رسائل إلى العملاء؛ تتم إدارته في قسمه الخاص للتحقق من الموافقة ومن İYS.',
  workflow_archived: 'لا يمكن تعديل مسار مؤرشف أو تشغيله.',
  workflow_active: 'لا يمكن أرشفة مسار قيد التشغيل؛ أوقفه أولًا.',
  workflow_run_not_retryable: 'لا تمكن إعادة المحاولة إلا لتنفيذ فاشل.',
  workflow_not_active: 'المسار غير مشغّل؛ شغّله قبل إعادة المحاولة.',
  workflow_run_not_cancellable: 'لا يمكن إلغاء إلا تنفيذ قيد الانتظار.',
  workflow_subject_missing: 'لا يحتوي الحدث على السجل الذي يحتاجه هذا الإجراء.',
  owner_inactive: 'عضوية الشخص الذي شغّل المسار غير نشطة.',
  no_recipient: 'لا يوجد عضو نشط يمكن مراسلته بهذا الإعداد.',
  seo_issues: 'توجد مشكلات في تحسين محركات البحث (SEO).',
  order_not_paid: 'الطلب ليس في حالة «مدفوع»؛ لم يُغيَّر.',
  order_not_found: 'الطلب غير موجود.',
  product_not_found: 'المنتج غير موجود.',
  post_not_found: 'المقال غير موجود.',
  already_published: 'النسخة المعتمدة منشورة بالفعل.',
  invoice_uncertain: 'نتيجة الفاتورة غير مؤكدة؛ تحقّق منها في BizimHesap وحدّد حالتها في صفحة الفواتير.',
  invoice_send_failed: 'تعذّر إرسال الفاتورة إلى BizimHesap؛ أعد إرسالها من صفحة الفواتير.',
  workflow_paused: 'تم إيقاف المسار؛ أُلغي التنفيذ قيد الانتظار.',
  manual_retry: 'أُعيدت محاولة التنفيذ يدويًا.',
  too_short: 'النص قصير جدًا.',
  invalid: 'قيمة غير صالحة.',
};

export const faz8PermissionsAr = {
  'reports.finance.manage': 'إدارة المدخلات المالية (قواعد رسوم الدفع، تكاليف الشحن، مصاريف التشغيل)',
  'purchasing.read': 'عرض الموردين والمشتريات (بما في ذلك التكاليف وأرصدة الموردين)',
  'purchasing.manage': 'إدارة الموردين وأوامر الشراء',
  'purchasing.receive': 'استلام البضائع (إدخال المخزون مقابل أوامر الشراء)',
  'purchasing.ledger.manage': 'قيود حساب المورّد (دفعات، مرتجعات، رصيد افتتاحي، تسويات)',
  'reports.custom.read': 'تشغيل التقارير المخصصة وعرض المشتركة منها (البيانات ضمن صلاحياتك)',
  'reports.custom.manage': 'حفظ التقارير المخصصة ومشاركتها',
  'reports.schedule.manage': 'التقارير المجدولة (روابط تنزيل بالبريد لأعضاء المنشأة)',
  'payments.dispute.manage': 'اعتراضات الدفع (رد المبالغ المدفوعة): التسجيل والحالة والملاحظات والمستندات',
  'workflows.read': 'عرض مسارات الأتمتة وسجل تنفيذها',
  'workflows.manage':
    'إنشاء مسارات الأتمتة وتشغيلها وإيقافها وإعادة محاولتها (تعمل الإجراءات بصلاحيات الشخص الذي شغّلها)',
};
